
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { ReactComponent as WinnerIcon } from "../image/winner_icon.svg";
import { ReactComponent as ExitIcon } from "../image/exit_icon.svg";
import { ReactComponent as ClapsIcon } from "../image/clap_icon.svg";
import { ReactComponent as SadFace } from "../image/sadface.svg";
import { ReactComponent as PlayMusicIcon } from "../image/play_music_icon.svg";
import { ReactComponent as StopMusicIcon } from "../image/stop_music_icon.svg";
import { ReactComponent as GridroundIcon } from "../image/grid_icon.svg";
import { ReactComponent as QuestionIcon } from "../image/Question.icon.svg";
import rope from "../image/rope.png";
import heavy_heart from "../image/topbaricons/heavy_heart.png";
import party_propper from "../image/topbaricons/party_popper.png";
import clap_hands from "../image/topbaricons/clap_hands.png";
import pile from "../image/topbaricons/pile.png";
import praise_hands from "../image/topbaricons/praise_hands.png";
import Smile_emoji from "../image/topbaricons/Smile_emoji.png";
import firework_sparkler from "../image/topbaricons/firework_sparkler.png";
import cry_face from "../image/topbaricons/cry_face.png";
import fingers_crossed from "../image/topbaricons/fingers_crossed.png";
import DownIcon from "../image/topbaricons/DownIcon .png";
import heartgif from "../image/topbaricons/heartgif.gif";
import confetti from "../image/topbaricons/confetti.gif";
import fireworkgif from "../image/topbaricons/fireworkgif.gif";
import MusicPlayer from "../Header/MusicPlayer";
import clapSound from "../Sounds/clap.wav";
import sad from "../Sounds/Sad.wav";
import firebase from "../firebase";
import CloseIcon from "@mui/icons-material/Close";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { IconButton } from "@mui/material";

import "../style/BasicHeader.css";

const BasicHeaderPlayScreen = ({
  onNavigate,
  styleData,
  audio,
  musicData,
  canPlay,
}) => {
  const buttonColor = useSelector((state) => state.gameSettings.buttonColor);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const platform = isIOS ? "iOS" : isAndroid ? "android" : "other";
  const backgroundColor = useSelector(
    (state) => state.backgroundColor.backgroundColor
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showImages, setShowImages] = useState(false);
  const [showGif, setShowGif] = useState(false);
  const [selectedImage, setSelectedImage] = useState(heavy_heart);
  const [selectedGif, setSelectedGif] = useState(null);
  const [animateImage, setAnimateImage] = useState(false);
  const [showMusicPlayer, setShowMusicPlayer] = useState(false);
  const logo = useSelector(state => state.logo.logo);
  const code = localStorage.getItem("code");
  const [showNextTurnModal, setShowNextTurnModal] = useState(false);
  const [showReturnToMainModal, setshowReturnToMainModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [questionText, setQuestionText] = useState("");
  const mobile = useSelector(state => state.mobile.isMobile);
  const [connectedStudent, setconnectedStudent] = useState([]);
  const { id: id } = useParams();
  const { clid: clid } = useParams();
  const localization = useSelector((state) => state.localization.localization);

  const gameName = useSelector((state) => state.gameName.gameName);
  const handleMouseEnter = () => {
    setShowMusicPlayer(true); // Show the MusicPlayer when the image is hovered
  };

  const handleMouseLeave = () => {
    setShowMusicPlayer(false); // Hide the MusicPlayer when the mouse leaves
  };
  const onCloseToggle = () => {
    setShowImages(false);
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        onCloseToggle();
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [onCloseToggle]);
  // const openWinnerScreen = () => {
  //   onNavigate("winnerscreen");
  // };

  const openWinnerScreen = () => {
    const fullPath = window.location.pathname;
    console.log('Full URL Path:', fullPath);

    // Check if 'm=cr' is part of the URL path
    const isCRParamPresent = fullPath.includes("m=cr");
    console.log('Is m=cr present:', isCRParamPresent);
    const isCLParamPresent = fullPath.includes("m=cl");
    console.log('Is m=cr present:', isCLParamPresent);

    if ((isCRParamPresent && code) || (isCLParamPresent && code)) {
      console.log("winner from participant");
      console.log("Code:", code); // Check if code is correctly retrieved
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);
      console.log("Database reference:", ref); // Check the database reference

      // Set `command` to `7010` in the database.
      ref.update({ command: '7010' })
        .then(() => {
          console.log("Command set to 7010 in the database.");
          onNavigate("winnerscreen");
        })
        .catch((error) => {
          console.error("Error updating command in the database:", error);
        });
    } else {
      onNavigate("winnerscreen");
    }
  };


  function sendToNative(stopaudio) {
    var native = window.webkit.messageHandlers.nativeProcess;
    native.postMessage(stopaudio);
  }
  // const handleExit = async () => {
  //   if (platform === "iOS") {
  //     sendToNative("ExitGame");
  //   } else {
  //     const userConfirmed = window.confirm("Are you sure you want to exit?");
  //     if (userConfirmed) {
  //       // Remove data from local storage before proceeding
  //       window.localStorage.removeItem('wordToGuess');
  //       window.localStorage.removeItem('guessedLetters');
  //       window.localStorage.removeItem('wrongGuesses');
  //       window.localStorage.removeItem('currentTeam');
  //       window.localStorage.removeItem('score');
  //       window.localStorage.removeItem('currentScreen');
  //       window.localStorage.removeItem('roundWinners');
  //       window.localStorage.removeItem('selectedRound');
  //       window.localStorage.removeItem('startTime');
  //       window.localStorage.removeItem('allocatedTeam');
  //       window.localStorage.removeItem('allocatedTeamColor');
  //       window.localStorage.removeItem('currentScreenParticipantside');
  //       window.localStorage.removeItem('initials');
  //       window.localStorage.removeItem('name');
  //       window.localStorage.removeItem('profileColor');
  //       window.localStorage.removeItem('startTime');

  //       const fullPath = window.location.pathname;
  //       console.log('Full URL Path:', fullPath);

  //       // Check if 'm=cr' is part of the URL path
  //       const isCRParamPresent = fullPath.includes("m=cr");
  //       console.log('Is m=cr present:', isCRParamPresent);
  //       const isCLParamPresent = fullPath.includes("m=cl");
  //       console.log('Is m=cr present:', isCLParamPresent);

  //       if ((isCRParamPresent && code) ||(isCLParamPresent && code)  ) {
  //         console.log("winner from participant");
  //         console.log("Code:", code); // Check if code is correctly retrieved
  //         const db = firebase.database();
  //         const ref = db.ref(`AppleTV/${code}`);
  //         console.log("Database reference:", ref); // Check the database reference

  //         try {
  //           // Set `command` to `7020` in the database.
  //           await ref.update({ command: '7020' ,      isParticipantGameStarted
  //             :
  //             false});
  //           console.log("Command set to 7020 in the database.");

  //           // Make a DELETE request to Firebase to remove the data associated with the code
  //           const response = await fetch(`https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`, {
  //             method: 'DELETE',
  //           });

  //           if (response.ok) {
  //             console.log('Data deleted successfully');
  //           } else {
  //             console.error('Error deleting data:', response.statusText);
  //           }
  //         } catch (error) {
  //           console.error("Error updating command in the database or deleting data:", error);
  //         }
  //       }

  //       // Redirect the user to another page after completing the above actions
  //       try {
  //         if (id?.includes("C")) {
  //           window.location.href = `https://triviamaker.com/corporate-game-preview/game/HM${id}`;
  //         } else {
  //           window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //         }
  //       } catch (error) {
  //         console.error("Error in redirecting:", error);
  //       }
  //     }
  //   }
  // };



  // final
  // const handleExit = async () => {
  //   if (platform === "iOS" || platform === "android") {
  //     sendToNative("ExitGame");
  //   } else {
  //     const userConfirmed = window.confirm("Are you sure you want to exit?");
  //     if (userConfirmed) {
  //       // Clean up localStorage
  //       const keysToRemove = [
  //         'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
  //         'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
  //         'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor','code'
  //       ];
  //       keysToRemove.forEach(key => window.localStorage.removeItem(key));

  //       const fullPath = window.location.pathname;
  //       console.log('Full URL Path:', fullPath);

  //       const isCRParamPresent = fullPath.includes("m=cr");
  //       const isCLParamPresent = fullPath.includes("m=cl");
  //       console.log('Is m=cr present:', isCRParamPresent);
  //       console.log('Is m=cl present:', isCLParamPresent);

  //       if ((isCRParamPresent || isCLParamPresent) && code) {
  //         console.log("Winner from participant");
  //         console.log("Code:", code);

  //         const db = firebase.database();
  //         const ref = db.ref(`AppleTV/${code}`);
  //         console.log("Database reference:", ref);

  //         try {
  //           // Update the Firebase database
  //           await ref.update({
  //             command: '7020',
  //             isParticipantGameStarted: false,
  //           });
  //           console.log("Command set to 7020 in the database.");

  //           // DELETE request to Firebase
  //           const response = await fetch(
  //             `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
  //             { method: 'DELETE' }
  //           );

  //           if (response.ok) {
  //             const keysToRemove = [
  //               'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
  //               'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
  //               'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor','code'
  //             ];
  //             keysToRemove.forEach(key => window.localStorage.removeItem(key));
  //             console.log('Data deleted successfully');
  //           } else {
  //             console.error('Error deleting data:', response.statusText);
  //           }
  //         } catch (error) {
  //           console.error("Error updating database or deleting data:", error);
  //         }
  //       }

  //       // Redirect the user
  //       try {
  //         if (id?.includes("C")) {
  //           window.location.href = `https://triviamaker.com/corporate-game-preview/game/HM${id}`;
  //         } else {
  //           window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //         }
  //       } catch (error) {
  //         console.error("Error in redirecting:", error);
  //       }
  //     }
  //   }
  // };


  const handleExit = async () => {
    console.log("exitgame");
    if (platform === "iOS" || platform === "android") {
      sendToNative("ExitGame");
    } else {
      const userConfirmed = window.confirm("Are you sure you want to exit?");
      if (userConfirmed) {
        // Clean up localStorage
        const keysToRemove = [
          'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
          'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
          'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
        ];
        keysToRemove.forEach(key => window.localStorage.removeItem(key));

        const fullPath = window.location.pathname;
        console.log('Full URL Path:', fullPath);

        const isCRParamPresent = fullPath.includes("m=cr");
        const isCLParamPresent = fullPath.includes("m=cl");
        console.log('Is m=cr present:', isCRParamPresent);
        console.log('Is m=cl present:', isCLParamPresent);

        if ((isCRParamPresent || isCLParamPresent) && code) {
          console.log("Winner from participant");
          console.log("Code:", code);

          const db = firebase.database();
          const ref = db.ref(`AppleTV/${code}`);
          console.log("Database reference:", ref);

          try {
            // Update the Firebase database
            await ref.update({
              command: '7020',
              isParticipantGameStarted: false,
            });
            console.log("Command set to 7020 in the database.");

            // Wait 3 seconds so participants receive the 7020 command before we delete
            await new Promise(resolve => setTimeout(resolve, 3000));

            // DELETE request to Firebase
            const response = await fetch(
              `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
              { method: 'DELETE' }
            );

            if (response.ok) {
              const keysToRemove = [
                'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
                'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
                'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
              ];
              keysToRemove.forEach(key => window.localStorage.removeItem(key));
              console.log('Data deleted successfully');
            } else {
              console.error('Error deleting data:', response.statusText);
            }
          } catch (error) {
            console.error("Error updating database or deleting data:", error);
          }
        }


        if (isCLParamPresent) {
          const timestamp = Date.now();
          const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;
          const response = await fetch(apiUrl);
          const data = await response.json(); // Parse the JSON response
          const currentDataResponseforclassroom = await axios.get(
            `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`
          );
          const currentDataforclassroom = currentDataResponseforclassroom.data;

          const sessionData = Array.isArray(data) ? data : [];
          const currentSession = sessionData[sessionData.length - 1];

          // Add the endtime to the currentSession
          if (currentSession) {
            currentSession.endtime = timestamp; // Set the endtime with the current timestamp
          }

          if (currentSession && currentSession.connectedstudents) {
            // Extract values before the '&' symbol
            const extractedStudents = currentSession.connectedstudents.map(student =>
              student.split('&')[0] // Get the part before '&'
            );

            setconnectedStudent(extractedStudents); // Update state with extracted values
            console.log('Connected students:', extractedStudents); // Log the extracted values

            // Update students data in currentDataforclassroom
            if (currentDataforclassroom && currentDataforclassroom.students) {
              currentDataforclassroom.students.forEach(student => {
                if (extractedStudents.includes(student.stuname)) {
                  // Increment gamecompleted and gameplayed by 1
                  student.gamecompleted = (student.gamecompleted || 0) + 1;
                  student.gameplayed = (student.gameplayed || 0) + 1;

                  // Match student's name with scores and update correctanswers
                  if (currentSession.scores) {
                    currentSession.scores.forEach(scoreEntry => {
                      if (scoreEntry.name && student.stuname.includes(scoreEntry.name)) {
                        // Add correctanswers from scores to the student
                        student.correctanswers = (student.correctanswers || 0) + scoreEntry.correctanswers;
                      }
                    });
                  }
                }
              });
            }
            console.log('Updated students:', currentDataforclassroom.students);
          }

          // Update the session in Firebase using PATCH (only update the current session)
          await axios.patch(apiUrl, {
            [`${sessionData.length - 1}`]: currentSession,  // Only update the last session
          });

          const newActivity = {
            status: `${gameName} Ended`,
            time: timestamp, // Time set to match starttime
          };
          if (currentDataforclassroom && currentDataforclassroom.Activities) {
            currentDataforclassroom.Activities.push(newActivity);
          } else {
            currentDataforclassroom.Activities = [newActivity];
          }
          await axios.put(
            `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`,
            currentDataforclassroom
          );
        }
        // Redirect the user
        try {
          if (id?.includes("C")) {
            window.location.href = `https://triviamaker.com/corporate-game-preview/game/HM${id}`;
          } else {
            window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
          }
        } catch (error) {
          console.error("Error in redirecting:", error);
        }
      }
    }
  };

  useEffect(() => {
    window.exitgame = handleExit;
  });

  const toggleImages = () => {
    setShowImages(!showImages);
  };

  const toggleGif = () => {
    setShowGif(true);
    setTimeout(() => setShowGif(false), 3000);
  };

  const handleImageSelect = (image, gif) => {
    setSelectedImage(image);
    setSelectedGif(gif);
    setShowImages(false);

    if (gif) {
      toggleGif();
      setAnimateImage(false); // Stop image animation if GIF is selected
    } else {
      setAnimateImage(true);
      setTimeout(() => setAnimateImage(false), 4000); // Animation duration
    }
  };

  const playClapSound = () => {
    const audio = new Audio(clapSound); // Create an audio instance
    audio.play(); // Play the clap sound
  };
  const sadClapSound = () => {
    const audio = new Audio(sad); // Create an audio instance
    audio.play(); // Play the clap sound
  };


  const openQuestion = () => {
    // Retrieve the 'selectedRound' item from local storage and parse it
    const selectedRoundData = JSON.parse(localStorage.getItem("selectedRound"));
    if (selectedRoundData && selectedRoundData.question) {
      setQuestionText(selectedRoundData.question); // Set the question text
    }
    setShowNextTurnModal(true); // Show the modal
  };

  const onCloseNextturn = () => {
    setShowNextTurnModal(false); // Close the modal
  };

  // retuen to main board function
  const openSplashScreen = () => {
    setshowReturnToMainModal(true); // Show the modal
  };

  // Close the modal without taking action
  const onCloseReturnToMainModal = () => {
    setshowReturnToMainModal(false); // Close the modal
  };

  // Function to handle confirmation (OK button click)
  const handleConfirm = () => {
    // Perform the same logic as the window.confirm
    window.localStorage.removeItem('wordToGuess');
    window.localStorage.removeItem('guessedLetters');
    window.localStorage.removeItem('wrongGuesses');
    window.localStorage.removeItem('currentTeam');
    window.localStorage.removeItem('score');
    onNavigate("splash"); // Assuming onNavigate is defined elsewhere for navigation

    // Close the modal after the action
    setshowReturnToMainModal(false);
  };


  return (
    <div className=" py-2 box" style={{ backgroundColor: backgroundColor }}>
      <div className="container-fluid custom-shadow" style={{
        paddingLeft: mobile ? "15px" : "0px",  // Apply 15px padding on mobile
        paddingRight: mobile ? "15px" : "0px", // Apply 15px padding on mobile
      }}>
        <div className="row align-items-center justify-content-between">
          <div className="col-4 d-flex align-items-center justify-content-start mb-2">
            <div className="tooltip-container">
              <WinnerIcon
                className="img-fluid me-1"

                onClick={openWinnerScreen}
                style={{ fill: buttonColor }}
              />
              <div className="tooltip-text">{localization.winner}</div>
            </div>
            <div className="tooltip-container">
              <ExitIcon
                className="img-fluid me-1"

                onClick={handleExit}
                style={{ fill: buttonColor }}
              />
              <div className="tooltip-text">{localization.exit_game}</div>
            </div>

            <div className="tooltip-container">
              <GridroundIcon
                className="img-fluid me-1"

                onClick={openSplashScreen}
                style={{ fill: buttonColor }}
              />
              <div className="tooltip-text">{localization.return_board}</div>
            </div>

            <div className="tooltip-container">
              <QuestionIcon
                className="img-fluid me-1"

                onClick={openQuestion}
                style={{ fill: buttonColor }}
              />
              <div className="tooltip-text">{localization.question}</div>
            </div>
          </div>

          <div className="col-4 d-flex align-items-center justify-content-center mb-2">
            <img src={logo} alt="logo Icon" className="logo" />
          </div>

          <div className="col-4 d-flex align-items-center justify-content-end mb-2">
            <div className="tooltip-container">
              <div
                className="dropdown me-2"
                style={{
                  border: `4px solid ${buttonColor}`,
                  borderRadius: "15px",
                  backgroundColor: "black",
                }}
              >
                <button
                  style={{
                    borderStyle: "none",
                    margin: "1px",
                    backgroundColor: "transparent",
                  }}
                  className="btn btn-secondary EmojiDropDown  btn-sm dropdown-toggle"
                  onClick={toggleImages}
                  id="dropdownMenuButton"
                  aria-expanded={showImages ? "true" : "false"}
                ></button>

                <button
                  className="EmojiDropDown"
                  style={{
                    borderStyle: "none",
                    backgroundColor: "black",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handleImageSelect(selectedImage, selectedGif);
                    toggleGif();
                  }}
                >
                  <img
                    src={selectedImage}
                    alt="Selected Icon"
                    style={{
                      width: "2.6vw",
                      verticalAlign: "middle",
                      borderStyle: "none",
                    }}
                  />
                </button>

                <ul
                  className={`dropdown-menu ${showImages ? "show" : ""}`}
                  aria-labelledby="dropdownMenuButton"
                  style={{
                    display: showImages ? "block" : "none",
                    backgroundColor: showImages ? "black" : "transparent",
                    padding: showImages ? "10px" : "0",
                    minWidth: "auto",
                    border: `4px solid ${buttonColor}`,
                    borderRadius: "15px",
                  }}
                >
                  <li onClick={() => handleImageSelect(heavy_heart, heartgif)}>
                    <img
                      src={heavy_heart}
                      alt="Heavy Heart"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li onClick={() => handleImageSelect(praise_hands, null)}>
                    <img
                      src={praise_hands}
                      alt="Praise Hands"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li onClick={() => handleImageSelect(clap_hands, null)}>
                    <img
                      src={clap_hands}
                      alt="Clap Hands"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li onClick={() => handleImageSelect(Smile_emoji, null)}>
                    <img
                      src={Smile_emoji}
                      alt="Smile Emoji"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li
                    onClick={() => handleImageSelect(party_propper, confetti)}
                  >
                    <img
                      src={party_propper}
                      alt="Party Popper"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li
                    onClick={() =>
                      handleImageSelect(firework_sparkler, fireworkgif)
                    }
                  >
                    <img
                      src={firework_sparkler}
                      alt="Firework Sparkler"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li onClick={() => handleImageSelect(cry_face, null)}>
                    <img
                      src={cry_face}
                      alt="Cry Face"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li onClick={() => handleImageSelect(fingers_crossed, null)}>
                    <img
                      src={fingers_crossed}
                      alt="Fingers Crossed"
                      className="mb-1 emoji p-1"
                    />
                  </li>
                  <li onClick={() => handleImageSelect(pile, null)}>
                    <img src={pile} alt="Pile" className="mb-1 emoji p-1" />
                  </li>
                </ul>
              </div>
              <div className="tooltip-text">{localization.emoji}</div>
            </div>
            <div className="tooltip-container">
              {/* <img src={clapsIcon} alt="Claps Icon" onClick={playClapSound} className="img-fluid me-1" /> */}
              <ClapsIcon
                className="img-fluid me-1"

                onClick={playClapSound}
                style={{ fill: buttonColor }}
              />
              <div className="tooltip-text">{localization.Applause}</div>
            </div>
            <div className="tooltip-container">
              {/* <img src={sadIcon} alt="Sad Icon" onClick={sadClapSound} className="img-fluid me-1" />
               */}
              <SadFace
                className="img-fluid me-1 "
                onClick={sadClapSound}
                style={{
                  fill: buttonColor || "black",
                }}
              />
              <div className="tooltip-text">{localization.sad}</div>
            </div>

            <div
              className="music-player-container me-1"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ position: "relative" }}
            >
              <PlayMusicIcon
                className="img-fluid me-1 "

                style={{
                  fill: buttonColor || "black",
                }}
              />
            </div>

            {showMusicPlayer && <div
              className="music-player-container"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ position: 'relative' }}
            ><MusicPlayer isOpen={showMusicPlayer} /></div>}


            <div
              className="music-player-container"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ position: "relative" }}
            >
              <StopMusicIcon
                className="img-fluid me-1 "
                style={{
                  fill: buttonColor || "black",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {showGif && selectedGif && (
        <div className="gifContainer">
          <img src={selectedGif} alt="Selected GIF" className="gif" />
        </div>
      )}

      {animateImage && !selectedGif && (
        <div className="emojiImgContainer">
          <img
            src={selectedImage}
            alt="Selected Icon"
            className={`emojiImg zoomAnimation`}
          />
        </div>
      )}

      <Modal
        className="custom-modal justify-content-center modal-dialog-centered"
        show={showNextTurnModal}
        onHide={onCloseNextturn} // Call the function here
      >
        <Modal.Body className="m-4">
          <div className="d-flex  justify-content-between align-item-end">
            <h5 className="playaloneText mb-4 ">Question</h5>
            <IconButton
              onClick={onCloseNextturn} // Call the function on close button click
              sx={{ color: "white" }}
              className="mb-3 "
            >
              <CloseIcon />
            </IconButton>
          </div>
          <p>{questionText}</p>
        </Modal.Body>
      </Modal>


      <Modal
        className="custom-modal justify-content-center modal-dialog-centered"
        show={showReturnToMainModal}
        onHide={onCloseReturnToMainModal} // Call the function here
      >
        <Modal.Body className="m-4">
          <div className="d-flex justify-content-between align-item-end">
            <h5 className="playaloneText mb-4 ">{localization.confirm_round_reset_message}</h5>
            <IconButton
              onClick={onCloseReturnToMainModal} // Close modal on close button click
              sx={{ color: "white" }}
              className="mb-3"
            >
              <CloseIcon />
            </IconButton>
          </div>
          {/* <p> You will lose the progress of this round.</p> */}
          <div className="d-flex justify-content-end">
            <button onClick={handleConfirm} className="btn  " style={{ marginRight: '10px', backgroundColor: buttonColor, color: "white" }}>OK</button>
            <button onClick={onCloseReturnToMainModal} className="btn btn-secondary ">Cancel</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BasicHeaderPlayScreen;